<script setup lang="ts">
import { useLanguage } from '#composables/useLanguage';
import ButtonBase from '../../../../../components/elements/button/ButtonBase.vue';

const emits = defineEmits<{
  click: [];
}>();

const { t } = useLanguage();
</script>

<template>
  <ButtonBase
    class="text-sm"
    icon-left="rotate-ccw"
    :label="t('dataTableInitButton.label')"
    variant="secondary"
    @click="emits('click')"
  />
</template>
